import { Component, HostListener, NgZone, OnInit } from '@angular/core';

import { ZoomMtg } from '@zoom/meetingsdk';
import { PostMessageKey } from 'src/app/models/post-message-key.enum';

interface StartMeetingOptions {
  signature: string;
  meetingNumber: number;
  userName: string;
  userEmail: string;
  sdkKey: string;
  passWord: string;
  leaveUrl: string;
  origin: string;
}

ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();

@Component({
  selector: 'app-meeting',
  templateUrl: './meeting.component.html',
  styleUrls: ['./meeting.component.scss']
})
export class MeetingComponent {

  @HostListener('window:message', ['$event']) onMessage(e): void {
    if (e.data && e.data.signature) {
      this.startMeeting({
        signature: e.data.signature,
        meetingNumber: e.data.meetingNumber,
        userName: e.data.userName,
        userEmail: e.data.userEmail,
        sdkKey: e.data.sdkKey,
        passWord: e.data.passWord,
        leaveUrl: e.data.leaveUrl,
        origin: e.data.origin
      });
    }
  }

  constructor(private ngZone: NgZone) { }

  private startMeeting({
    signature,
    meetingNumber,
    userName,
    userEmail,
    sdkKey,
    passWord,
    leaveUrl,
    origin
  }: StartMeetingOptions): void {
    document.getElementById('zmmtg-root').style.display = 'block'

    this.ngZone.runOutsideAngular(() => {
      ZoomMtg.init({
        leaveUrl: `${window.location.origin}/end?url=${leaveUrl}&origin=${origin}`,
        isSupportAV: true,
        success: () => {
          ZoomMtg.join({
            signature,
            meetingNumber,
            userName,
            userEmail,
            sdkKey,
            passWord,
            success: () => {
              parent.postMessage({ status: PostMessageKey.WEBINAR_STARTED }, origin);
            },
            error: () => {}
          });
        }
      });
    })

  }
}
